import React from 'react'
import { withRouter } from 'react-router-dom'

import { AuthContext } from '../../../main/authProvider'
import ConstantsUtil from '../../../context/constantsUtil'
import UploadDeArquivosCard from '../../../components/upload/uploadDeArquivosCard'

// passos que aparecem no painel "Como funciona" ao lado do upload
const passosComoFuncionaImportacaoFolha = [
    {
        titulo: 'Arquivo de Remessa',
        texto: 'Obtenha o arquivo de remessa da folha de pagamento (CNAB txt).',
    },
    {
        titulo: 'Envie o arquivo',
        texto: 'Arraste o .txt para a área ao lado ou escolha pelo computador.',
    },
    {
        titulo: 'Provisões criadas',
        texto: 'O sistema lê cada pagamento da remessa e cria as provisões a pagar automaticamente.',
    },
    {
        titulo: 'Unificação',
        texto: 'Para melhor visualização, no fluxo de caixa previsto, as provisões aparecerão unificadas, enquanto na conciliação bancária, aparecerão individualizadas.',
    },
]

class ImportarFolhaDePagamento extends React.Component {

    render() {
        return (
            <div className="bs-docs-section" style={{padding: '8px 16px 40px'}}>
                <UploadDeArquivosCard
                    titulo="Importar Folha de Pagamento"
                    subtitulo="Envie o arquivo de remessa CNAB da folha para gerar as provisões a pagar."
                    icone="pi pi-users"
                    accept=".txt"
                    tamanhoMaximoEmMB={20}
                    textoDica="Apenas 1 arquivo .txt (CNAB) · até 20MB"
                    uploadDescription={ConstantsUtil.importacaoRemessaFolhaDePagamentoDescricao}
                    textoBotaoEnviar="Importar e gerar provisões"
                    textoProcessando="Processando remessa e gerando provisões"
                    successNoticeMessage="Provisões da folha de pagamento criadas com sucesso!"
                    failNoticeMessage="Falha ao processar o arquivo. Tente novamente."
                    passosComoFunciona={passosComoFuncionaImportacaoFolha}
                />
            </div>
        )
    }

}

ImportarFolhaDePagamento.contextType = AuthContext

export default withRouter(ImportarFolhaDePagamento)
